// extracted by mini-css-extract-plugin
export default {"socialProviderButton":"SocialButtons_socialProviderButton__C28pi","icon":"SocialButtons_icon__OE5EK","disabled":"SocialButtons_disabled__rwAbg"};